import React from "react";

import robot from "../../assets/img/robot.png";

class Error extends React.Component {
  render() {
    return (
      <div className="Error">
        <div className="uk-card uk-card-default uk-card-body">
          <div className="uk-flex uk-flex-column uk-flex-middle">
            <img className="uk-img" src={robot} width="256" />
            <h3 className="uk-text-lead uk-text-bold uk-margin-remove-bottom">
              Opps! Something Went Wrong
            </h3>
            <h2>
              We are sorry, but our team of qualified monkeys are working on it
            </h2>
            <button
              className="uk-button uk-button-primary uk-margin-top"
              type="button"
              onClick={() => this.props.history.replace("/merchants")}
            >
              <span className="uk-text-middle uk-text-bold">Back to Home</span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default Error;
